export const validateTemplateName = (name: string): string[] => {
  if (!name || !name.trim()) {
    return ['フォルダ名を入力してください']
  }
  return []
}
